export const CopyIcon = ({ className, onClick }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#A5A5A5" />
      <g clipPath="url(#clip0_1554_8725)">
        <path
          d="M19.125 19.125H22.875V9.125H12.875V12.875"
          stroke="#070707"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.125 12.875H9.125V22.875H19.125V12.875Z"
          stroke="#070707"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1554_8725">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
